import { FC, useEffect } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { logout } from '../../services/AuthService';

interface ActivityProps {
  listenForEvents: Array<string>;
  timeout: number;
}

/**
 * @component ActivityMonitor
 * @description Renders the idle time out monitor component
 */
const ActivityMonitor: FC<ActivityProps> = (props: ActivityProps) => {
  const { listenForEvents, timeout } = props;
  const { keycloak } = useKeycloak();
  let timeoutInterval: NodeJS.Timeout | undefined;

  const setTimer = (): void => {
    clearInterval(timeoutInterval as NodeJS.Timeout);
    // if there is no timeout value then don't start a timer
    if (timeout <= 0) {
      return;
    }

    timeoutInterval = setTimeout(() => {
      const logoutURL = window.location.origin;
      logout();
      keycloak.logout({ redirectUri: logoutURL });
    }, timeout * 1000);
  };

  useEffect(() => {
    listenForEvents.forEach((event: string) => window.addEventListener(event, setTimer));
    setTimer();

    return () => {
      clearInterval(timeoutInterval as NodeJS.Timeout);
      listenForEvents.forEach((event: string) => window.removeEventListener(event, setTimer));
    };
  }, []);

  return null;
};

export default ActivityMonitor;
